import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {

  constructor(private toastr: ToastrService) {}

  success(title: string, message: string) {
    this.toastr.success(message, title);
  }

  error(title: string, message: string) {
    this.toastr.error(message, title);
  }

  errorWithWait(title: string, message: string, timeout = 30000) {
    if (timeout === 0) {
      timeout = 30000;
    }

    this.toastr.error(message, title, {
      timeOut: timeout,
      closeButton: true
    });
  }
}